export enum DesignatedUnitParticipationTypeIdEnum {
  Optional = 1,
  Mandatory
}
